import React, { useState } from "react";
import { connect } from "react-redux";
import { setActiveConversation } from "../../store/actions";
import { FaMicrophone, FaMicrophoneSlash, FaVideo, FaVideoSlash, FaUserShield, FaUserMinus, FaComment } from "react-icons/fa";
import { muteParticipant, removeParticipant } from "../../utils/wss.js";

const SingleParticipant = (props) => {
  const {
    identity,
    lastItem,
    participant,
    setActiveConversationAction,
    socketId,
    isRoomHost,
    roomId,
    currentUserSocketId,
  } = props;

  const [isMuted, setIsMuted] = useState(false);
  const [imageError, setImageError] = useState(false);

  // Check if this is the current user
  const isCurrentUser = participant.socketId === currentUserSocketId;

  // Check if this is the host (first participant)
  const isHost = participant.socketId === props.participants[0]?.socketId;

  const handleOpenActiveChatbox = () => {
    if (participant.socketId !== currentUserSocketId) {
      setActiveConversationAction(participant);
    }
  };

  const handleMuteParticipant = (e) => {
    e.stopPropagation();
    if (!isCurrentUser && isRoomHost) {
      muteParticipant(participant.socketId, roomId);
      setIsMuted(true);
    }
  };

  const handleRemoveParticipant = (e) => {
    e.stopPropagation();
    if (!isCurrentUser && isRoomHost) {
      if (window.confirm(`Remove ${identity} from the meeting?`)) {
        removeParticipant(participant.socketId, roomId);
      }
    }
  };

  // Get initials from identity
  const getInitials = (name) => {
    return name
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  // Handle image load error
  const handleImageError = () => {
    setImageError(true);
  };

  return (
    <>
      <div
        className="participant_item"
        onClick={handleOpenActiveChatbox}
        style={{
          cursor: isCurrentUser ? 'default' : 'pointer',
          opacity: isCurrentUser ? 0.8 : 1
        }}
      >
        <div className="participant_info">
          <div className="participant_avatar">
            {participant.photoURL && !imageError ? (
              <img
                src={participant.photoURL}
                alt={identity}
                onError={handleImageError}
                style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }}
              />
            ) : (
              getInitials(identity)
            )}
          </div>
          <div className="participant_name" style={{ fontSize: '14px' }}>
            {identity}
            {isCurrentUser && !isHost && <span style={{ marginLeft: '6px', color: '#a0a0a0', fontSize: '12px' }}>(You)</span>}
          </div>
        </div>

        <div className="participant_actions">
          {/* Show mute button for host to control other participants */}
          {isRoomHost && !isCurrentUser && !isHost && (
            <>
              <button
                className="action_button mute_btn tooltip"
                onClick={handleMuteParticipant}
                data-tooltip="Mute participant"
              >
                {isMuted ? <FaMicrophoneSlash /> : <FaMicrophone />}
              </button>
              <button
                className="action_button remove_btn tooltip"
                onClick={handleRemoveParticipant}
                data-tooltip="Remove from meeting"
              >
                <FaUserMinus />
              </button>
            </>
          )}

          {/* Chat button for all participants except self */}
          {!isCurrentUser && (
            <button
              className="action_button tooltip"
              onClick={(e) => {
                e.stopPropagation();
                handleOpenActiveChatbox();
              }}
              data-tooltip="Send private message"
            >
              <FaComment />
            </button>
          )}
        </div>
      </div>
    </>
  );
};

const Participants = ({
  participants,
  setActiveConversationAction,
  socketId,
  isRoomHost,
  roomId,
}) => {
  if (!participants || participants.length === 0) {
    return (
      <div style={{
        padding: '20px',
        textAlign: 'center',
        color: '#a0a0a0'
      }}>
        No participants in the meeting
      </div>
    );
  }

  return (
    <div className="participants_list">
      {participants.map((participant, index) => {
        return (
          <SingleParticipant
            key={participant.socketId || index}
            lastItem={participants.length === index + 1}
            participant={participant}
            identity={participant.identity}
            setActiveConversationAction={setActiveConversationAction}
            socketId={socketId}
            currentUserSocketId={socketId}
            isRoomHost={isRoomHost}
            roomId={roomId}
            participants={participants}
          />
        );
      })}
    </div>
  );
};

const mapStoreStateToProps = (state) => {
  return {
    ...state,
  };
};

const mapActionsToProps = (dispatch) => {
  return {
    setActiveConversationAction: (activeConversation) =>
      dispatch(setActiveConversation(activeConversation)),
  };
};

export default connect(mapStoreStateToProps, mapActionsToProps)(Participants);
